import { useLayoutEffect, useMemo, useRef } from 'react';
import type { CrudApiService } from 'framework/crud';

export type SyberryTodayApiTransport = Pick<CrudApiService, 'sendGetRequest' | 'sendPostRequest' | 'sendPutRequest'>;

export const useStableSyberryTodayApiTransport = (transport: SyberryTodayApiTransport): SyberryTodayApiTransport => {
  const transportRef = useRef(transport);

  useLayoutEffect(() => {
    transportRef.current = transport;
  }, [transport]);

  return useMemo(
    () => ({
      sendGetRequest: (...args: Parameters<SyberryTodayApiTransport['sendGetRequest']>) =>
        transportRef.current.sendGetRequest(...args),
      sendPostRequest: (...args: Parameters<SyberryTodayApiTransport['sendPostRequest']>) =>
        transportRef.current.sendPostRequest(...args),
      sendPutRequest: (...args: Parameters<SyberryTodayApiTransport['sendPutRequest']>) =>
        transportRef.current.sendPutRequest(...args),
    }),
    [],
  );
};
